import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { AssignmentGroupService } from '../../../system-admin/assignment-group/services/assignment-group.service';
import { UsersService } from '../../../shared/services/users.service';
import { CourseConstants } from '../../constants/course.constants';
import { CourseService } from '../../services/course.service';
import { cloneDeep } from 'lodash-es';
import { Course } from '../../models/course';
import { CoursePersistenceService } from '../../services/course-persistence.service';
import { CourseFormatConstants } from '../../constants/courseFormat.constants';
import { ValidityPeriod } from '../../models/validityPeriod';
import { CourseScoringOptionConstants } from '../../constants/courseScoringOption.constants';
import { CourseStatusConstants } from '../../constants/courseStatus.constants';
import { debounceTime, Subscription, Observable, Subject, firstValueFrom, lastValueFrom, concat } from 'rxjs';
import { AssignmentGroupsRequest } from '../../../document/models/assignment-groups-request';
import { AssignmentGroupSharedDataService } from '../../../shared/services/assignment-group-shared-data.service';
import { Router } from '@angular/router';
import { CourseProficiencyQuizConstant } from '../../constants/CourseProficiencyQuiz.constants';
import { UserType } from '../../../../app/shared/enums/user-type';

@Component({
  selector: 'app-course-general-details',
  templateUrl: './course-general-details.component.html',
  styleUrls: ['./course-general-details.component.scss']
})
export class CourseGeneralDetailsComponent implements OnInit {
  @Output() activateTabIndex = new EventEmitter<number>();
  debouncedUserListFn: Subject<any> = new Subject();
  private getCourseDetailsSubscription?: Subscription;
  initialCourseFormState: any;
  isCourseSaveInProgress = false;
  courseSaveProgressMessage =
    CourseConstants.Course_Save_InProgress;
  errorMessages: string[] = [];
  errorMessageHeaderText: string =
    CourseConstants.Course_Error_Message_Header_Text;
  courseForm!: FormGroup;
  mandatoryFields = this.getDefaultMandatoryFieldsObject();
  valueField: string = 'value';
  labelField: string = 'name';
  userList:any=[];
  ownersUserList:any=[];
  qualifiedTrainersUserList:any=[];
  serviceCourseData: any = {};
  courseBindData : any = {};
  eQMSScopesList: any =[];
  scopeList:any=[];
  courseDetails !: Course
  ifFormatIsInstructorLed: boolean = false;
  ifEqmsScopeIsSelected: boolean = false;
  ifScoringOptionIsMinimumScore:boolean = false;
  isCallForSave: boolean = false;
  courseFormControlDisabledByDefault:string[] = CourseConstants.CourseFormControls_Disabled_ByDefault;
  validityPeriodToolTip: string = CourseConstants.ValidityPeriod_InformationToolTip;
  assignmentGroups: any = []
  isFormatSelfStudy : boolean = false;
  usersAndAssignmentGroupList : any = [];
  usersAndAssignmentGroupListForQualifiedTrainers : any = [];
  usersAndAssignmentGroupListForCourseOwners : any = [];
  usersAndAssignmentGroupListOnEdit : any = [];
  usersAndAssignmentGroupListOnEditForQualifiedTrainers : any = [];
  usersAndAssignmentGroupListOnEditCourseOwners : any = [];
  isValidityPeriodRangeEntered: boolean = false;
  assignmentGroupsSubscription: Subscription | undefined;
  assignedList: any;
  courseNumber:any;
  courseInfo:any;
  eQMSScope:number[] = [];
  isEditSliderClosed = false;
  courseDetailsForEdit!:Course;
  isFormatEnabled!:boolean;
  qualifiedTrainersNameList:string[]=[];
  isInActiveAssignmentGroupDialog:boolean=false;
  isEditSlider:boolean=false;
  
  usersListToValidate:any=[];
  validatedUsersList:any=[];
  inactiveUserSelected:any;
  inactiveGroupsSelected:any;
  InactiveAssignmentGroupField = '';
  ownersWithInactiveUserList:any=[];
  qualifiedTrainersWithInactiveUsers:any=[];
  usersWithInactiveUsersAndAssignmentGroups:any=[];
  usersWithInactiveUsersAndAssignmentGroupsForMapping:any=[];



  readonly documentAssignmentTypes = [
    CourseConstants.AssignmentGroup_QualifiedTrainerAssignment, 
    CourseConstants.AssignmentGroup_CourseOwnerAssignment
  ];
  constructor(private _formBuilder: FormBuilder,private usersService: UsersService,
     private assignmentGroupService:AssignmentGroupService, private courseService:CourseService,
     private coursePersistenceService: CoursePersistenceService,
     private assignmentGroupSharedDataService:AssignmentGroupSharedDataService,
     private router: Router

     ){
      this.debouncedUserListFn
      .pipe(debounceTime(500))
      .subscribe((scopes) => {
        this.initialiseUserList(scopes).subscribe(() => {});
      });
     }

  ngOnInit(): void {
    this.courseForm = this.createFormGroupWithBuilderAndModel();
    this.initialise();
    this.setCourseSliderToDefaults();
    this.disableControls(this.courseFormControlDisabledByDefault)
    this.coursePersistenceService.closeAndResetCourseSlider$.subscribe((isClose) => {
      if (isClose) { 
        this.isEditSliderClosed = isClose;
        if(this.isEditSlider){
          this.eQMSScope = this.initialCourseFormState.eqmsScopes;       
          this.errorMessages = [];
          this.initialiseUserList(this.eQMSScope, isClose).subscribe(() => {
            this.courseForm.reset(this.initialCourseFormState);
          });

          this.mandatoryFields = this.getDefaultMandatoryFieldsObject();
        }
        else{
          this.closeAndResetCourseSlider(); 
        }       
      }
    });
      this.courseService.editCourseSlider$.subscribe((isEditSlider)=>{
      this.isEditSlider = isEditSlider;
      this.isEditSliderClosed = false;
    });

    this.coursePersistenceService.currentTabInSliderMenu$.subscribe((tabIndex) => {
      if (tabIndex === CourseConstants.Course_Create_General_Tab_Index) {
        this.updateCourseDetailsOnTabChange();
      }
    })
  }
  private getDefaultMandatoryFieldsObject() {
    return {
      name: false,
      status: false,
      format: false,
      eqmsScopes: false,
      description: false,
      owners: false,
      estimatedDuration:false,
      scoringOptions:false,
      qualifiedTrainers:false,
      recommendedMaxAttendees:false,
      minimumPassingScore:false,
      validityPeriodInterval: false,
      proficiencyQuiz: false,
      validityPeriodRange:false
    };
  }

  initialise() {

  this.courseService
    .geteQMSScopesForCourse()
    .subscribe((eQMSScopLookup: any[]) => {
      for (let dataItem of eQMSScopLookup) {
        this.eQMSScopesList.push({
          value: dataItem.eQMSScopeId,
          name: dataItem.eQMSScopeName,
        });
        this.scopeList.push({
          id: dataItem.eQMSScopeId,
          name: dataItem.eQMSScopeName,
          parentId: ''
        });
      }})
  this.getCourseDetailsSubscription = this.courseService.getCourseDetails().subscribe((serviceData) => {
    this.serviceCourseData = cloneDeep(serviceData);
    this.createData();
  }); 
}

  ngOnDestroy(): void {
    this.getCourseDetailsSubscription?.unsubscribe();
  }

  private setCourseSliderToDefaults(){
    this.courseService.editCourseSlider$.subscribe((isEditSlider)=>{
    if(isEditSlider)
    {
      this.isFormatEnabled=true;
      this.loadEditCourseSlider();
      this.courseForm.patchValue({
        status: this.validate(this.courseDetailsForEdit?.status)? this.courseDetailsForEdit?.status  : null,
        scoringOptions: this.validate(this.courseDetailsForEdit?.scoringOptions)? this.courseDetailsForEdit?.scoringOptions: null,
        proficiencyQuiz: this.validate(this.courseDetailsForEdit?.proficiencyQuiz)? this.courseDetailsForEdit?.proficiencyQuiz: null,
      })
    }
    else{
    if(!!this.courseForm){
      this.isFormatEnabled=false;
      this.courseForm.patchValue({
        status: CourseStatusConstants.Status_Active,
        scoringOptions: CourseScoringOptionConstants.Pass_Fail,
        proficiencyQuiz: CourseProficiencyQuizConstant.None,
      })
    }
  }
    });
    
  }

  mapCourseToCourse(){
    let formValues = this.courseForm.getRawValue();
    if(formValues.validityPeriodRange == ""){
      formValues.validityPeriodRange = null;
    }
    let validityPeriod : ValidityPeriod = {
      range:formValues.validityPeriodRange,
      interval: formValues.validityPeriodInterval
    }
    // TODO: Need to get Qualified Trainer assignment type Value
    this.assignedList = this.courseInfo?.qualifiedTrainers; 
    this.courseDetails={
      courseNumber: this.courseNumber,
      name: formValues.name,
      status: formValues.status,
      format: formValues.format,
      type: formValues.type,
      legacyCourseNumber:formValues.legacyCourseNumber,
      validityPeriod: validityPeriod,
      eqmsScopes: formValues.eqmsScopes,
      description:formValues.description,
      owners: this.assignmentGroupSharedDataService.updateUserToAssignmentTypeArrayForCourse(this.usersWithInactiveUsersAndAssignmentGroupsForMapping, formValues.owners, this.assignmentGroups, this.usersWithInactiveUsersAndAssignmentGroups) ?? [],
      qualifiedTrainers: this.assignmentGroupSharedDataService.updateUserToAssignmentTypeArrayForCourse(this.usersWithInactiveUsersAndAssignmentGroupsForMapping, formValues.qualifiedTrainers, this.assignmentGroups, this.usersWithInactiveUsersAndAssignmentGroups),
      recommendedMaxAttendees:formValues.recommendedMaxAttendees,
      estimatedDuration:formValues.estimatedDuration,
      scoringOptions:formValues.scoringOptions,
      minimumPassingScore:formValues.minimumPassingScore,
      proficiencyQuiz:formValues.proficiencyQuiz
    }

  }

  closeAndResetCourseSlider(){
    this.courseForm.reset();
    this.setCourseSliderToDefaults();
    this.disableControls(this.courseFormControlDisabledByDefault);
    this.errorMessages = [];
    this.userList = [];
    this.ownersUserList = [];
    this.qualifiedTrainersUserList = [];
    this.mandatoryFields = this.getDefaultMandatoryFieldsObject();
  }

  loadEditCourseSlider() {
    if (true) {
      var url = this.router.url;
      if (url.includes('courses/')) {
        this.courseNumber = url.substring(url.lastIndexOf('/') + 1, url.length);
      }
      this.loadCourseSliderWithDetails(this.courseNumber);
    }
  }


  async loadCourseSliderWithDetails(courseNumber: any) {
      
    // Fetch course data while editing
    if(courseNumber!==null || courseNumber!==undefined)
    {
      this.courseInfo = await this.courseService.getCourse(courseNumber).toPromise();
       this.eQMSScope = this.courseInfo?.eqmsScopes;
  
      // Check if user list is empty
      if (this.userList?.length === 0) {
        // Initialize user list
        await this.initialiseUserList(this.eQMSScope).toPromise();
      }
  
      // Populate course details for editing
      await this.populateCourseDetailsForEdit();
    }
  }
  
  

  initialiseUserList(eqmsScopes: any, isClose?: boolean) {
    return new Observable<void>((observer) => {
      this.userList = [];
      this.ownersUserList = [];
      this.usersAndAssignmentGroupList = [];
      this.qualifiedTrainersUserList = [];
      
      this.usersService.getUsersForCourse(eqmsScopes).subscribe(async (usersData) => {       
        for (let dataItem of usersData) {
          this.userList.push({
            value: dataItem.name,
            name: dataItem.name
          });
        }
        this.ownersUserList = [...this.userList];
        this.usersAndAssignmentGroupList = [...this.userList];
        this.qualifiedTrainersUserList = [...this.usersAndAssignmentGroupList];
        this.usersWithInactiveUsersAndAssignmentGroupsForMapping=[...this.userList];

          if (this.isEditSlider && !isClose) {
            await this.getAssignementGroupsForEachScopeOnEdit();
          } else {
            this.getAssignementGroupsForEachScope(eqmsScopes);
          }
        observer.next();
        observer.complete();
      });
    });
  }

  validateEqmsScopes(){
    const eqmsScopes = this.courseForm.getRawValue()?.eqmsScopes;
    const scopesAreDifferent = this.compareCurrentAndPreviousScopes(this.eQMSScope, eqmsScopes);
    this.eQMSScope = eqmsScopes;
    if(eqmsScopes?.length> 0)
    {
      if (this.assignmentGroupsSubscription) {
        this.assignmentGroupsSubscription.unsubscribe();
      }
      if(scopesAreDifferent || this.userList.length == 0){     
        this.debouncedInitialiseUserList(eqmsScopes);
      }

      this.enableControls(CourseConstants.CourseFormControls_Owners);
      if(this.ifFormatIsInstructorLed){
        this.enableControls(CourseConstants.CourseFormControls_QualifiedTrainers);
      }
    this.ifEqmsScopeIsSelected = true;
    }
    else{
      this.courseForm.patchValue({
        owners:null,
        qualifiedTrainers: null
      })
      this.userList = [];
      this.ownersUserList = [];
      this.qualifiedTrainersUserList = [];
      this.usersAndAssignmentGroupList = [];
      this.ifEqmsScopeIsSelected = false;
      this.disableControls(CourseConstants.CourseFormControls_Owners);
      this.disableQualifiedTrainers();
    }  
}

debouncedInitialiseUserList = (eqmsScopes: any) => {
  this.debouncedUserListFn.next(eqmsScopes);
};

  compareCurrentAndPreviousScopes(previousScopeSelected: number[] | null | undefined, currentScopeSelected: number[] | null | undefined): boolean {
    if (!previousScopeSelected || !currentScopeSelected) {
      return true;
    }
  
    if (previousScopeSelected.length !== currentScopeSelected.length) {
      return true;
    }
  
    // Check if both the scopes contain the same values or not
    const isDifferent = !previousScopeSelected.every((element) => currentScopeSelected.includes(element)) || 
                        !currentScopeSelected.every((element) => previousScopeSelected.includes(element));
    
    return isDifferent;
  }
  
  createData(){
    this.courseBindData.statuses=this.serviceCourseData.statuses;
    this.courseBindData.types = this.serviceCourseData.types;
    this.courseBindData.formats = this.serviceCourseData.formats;
    this.courseBindData.scoringOptions = this.serviceCourseData.scoringOptions;
    this.courseBindData.proficiencyQuizTypes = this.serviceCourseData.proficiencyQuizTypes;
  }

  createFormGroupWithBuilderAndModel(){
    return this._formBuilder.group({
      courseNumber: new FormControl(),
      name: new FormControl('', [Validators.required]),
      status: new FormControl(null, [Validators.required]),
      format: new FormControl(null,[Validators.required]),
      type: new FormControl(),
      legacyCourseNumber:new FormControl(),
      validityPeriodRange: new FormControl(null, [Validators.min(1)]),
      validityPeriodInterval:new FormControl(),
      eqmsScopes: new FormControl(null,[Validators.required]),
      description:new FormControl('',[Validators.required]),
      owners:new FormControl(null,[Validators.required]),
      qualifiedTrainers:new FormControl(),
      recommendedMaxAttendees:new FormControl(),
      estimatedDuration:new FormControl(),
      scoringOptions: new FormControl(null,[Validators.required]),
      minimumPassingScore:new FormControl(),
      proficiencyQuiz:new FormControl(null,[Validators.required])
    })
  }

  async populateCourseDetailsForEdit():Promise<void>
  {
  this.constructEditCourseDetails();
  await this.processUsersList();
  let validityPeriodData : ValidityPeriod = {
    range:this.courseDetailsForEdit?.validityPeriodValue?.range,
    interval: this.courseDetailsForEdit?.validityPeriodValue?.interval
  }

  this.courseForm.patchValue({
  name:this.courseDetailsForEdit?.name,
  status: this.validate(this.courseDetailsForEdit?.status)? this.courseDetailsForEdit?.status  : null,
  format: this.validate(this.courseDetailsForEdit?.format)? this.courseDetailsForEdit?.format  : null,
  type: this.validate(this.courseDetailsForEdit?.type)? this.courseDetailsForEdit?.type: null,
  legacyCourseNumber: this.courseDetailsForEdit?.legacyCourseNumber,
  validityPeriodRange:validityPeriodData.range,
  validityPeriodInterval:validityPeriodData.interval,
  eqmsScopes: this.courseDetailsForEdit?.eqmsScopes,
  description:this.courseDetailsForEdit?.description,
  owners:this.courseDetailsForEdit?.owners.map(user=>user.assignedUserName),
  qualifiedTrainers:this.courseDetailsForEdit?.qualifiedTrainers!=null || this.courseDetailsForEdit?.qualifiedTrainers!=undefined?this.courseDetailsForEdit?.qualifiedTrainers.map(user=>user.assignedUserName):null,
  recommendedMaxAttendees:this.courseDetailsForEdit?.recommendedMaxAttendeesValue,
  estimatedDuration:this.courseDetailsForEdit?.estimatedCourseDurationValue,
  scoringOptions:this.validate(this.courseDetailsForEdit?.scoringOptions)? this.courseDetailsForEdit?.scoringOptions: null,
  minimumPassingScore:this.courseDetailsForEdit?.minimumPassingScoreValue,
  proficiencyQuiz:this.validate(this.courseDetailsForEdit?.proficiencyQuiz) ? this.courseDetailsForEdit?.proficiencyQuiz : null,
},
  { emitEvent: false, onlySelf: true });


  if(this.courseForm.getRawValue().scoringOptions == CourseScoringOptionConstants.MinimumScore){
    this.enableControls(CourseConstants.CourseFormControls_MinimumPassingScore);
    this.ifScoringOptionIsMinimumScore = true;
  }
  if(validityPeriodData.range!== undefined && validityPeriodData.range > 0){
    this.enableControls(CourseConstants.CourseFormControls_ValidityPeriodInterval);
    this.isValidityPeriodRangeEntered = true;
  }
  else{
    this.disableControls(CourseConstants.CourseFormControls_ValidityPeriodInterval);
    this.courseForm.patchValue({
      validityPeriodInterval : null
    })
    this.isValidityPeriodRangeEntered = false;

  }

  // Initialize the state of the form
  // To-do -> when we remove reload on save then we have to alter this.
  this.initialCourseFormState = this.courseForm.getRawValue();
  this.mapCourseToCourse();
  this.coursePersistenceService.updateCourseDetails(this.courseDetails);
}


openNextTab = () => {
  this.validateForm();
  this.courseService.editCourseSlider$.subscribe((isEditCourse)=>{
    let isEditSlider = isEditCourse;
    if (this.errorMessages.length === 0) {
      this.mapCourseToCourse();
      if (isEditSlider) {
        this.coursePersistenceService.updateTabErrorIndex(CourseConstants.Course_Create_General_Tab_Index, false);
        if(this.courseDetails.validityPeriod?.interval=== null || this.courseDetails.validityPeriod?.range === null){
          this.courseDetails.validityPeriod = undefined;
        }

        // isCallForSave flag is set False, Only Verification needed for Inactive Assignment Group if present in Qualified Trainer
        this.isCallForSave = false;

        // False parameter is for validating and not updating the Course in database
        this.verifyIfCourseContainsInActiveAGForUpdate(this.courseDetails, false);
      }
      this.coursePersistenceService.updateCourseDetails(this.courseDetails);
      this.activateTabIndex.emit(
        CourseConstants.Course_Prerequisites_Index
      );
      this.coursePersistenceService.onCustomTabChange(CourseConstants.Course_Prerequisites_Index);
    } else {
      if (isEditSlider) {
        this.mapCourseToCourse();
        this.coursePersistenceService.updateCourseDetails(this.courseDetails);
        this.coursePersistenceService.updateTabErrorIndex(CourseConstants.Course_Create_General_Tab_Index, true);
        this.activateTabIndex.emit(
          CourseConstants.Course_Prerequisites_Index
        );
        this.coursePersistenceService.onCustomTabChange(CourseConstants.Course_Prerequisites_Index);
      }
      else
        document.querySelector('.p-tabview-panels')?.scrollTo(0, 0);
    }
  });
  
};

updateCourseDetailsOnTabChange = () => {
  this.validateForm();
  if (this.errorMessages.length === 0) {
    this.coursePersistenceService.updateTabErrorIndex(CourseConstants.Course_Create_General_Tab_Index, false);
    this.mapCourseToCourse();
    this.coursePersistenceService.updateCourseDetails(this.courseDetails);
  } else {
    if (this.isEditSlider) {
      this.mapCourseToCourse();
      this.coursePersistenceService.updateCourseDetails(this.courseDetails);
    }
    this.coursePersistenceService.updateTabErrorIndex(CourseConstants.Course_Create_General_Tab_Index, true);
  }
}

  private constructEditCourseDetails() {
    this.courseDetailsForEdit = JSON.parse(
      JSON.stringify(this.courseInfo)
    );
    if(this.courseInfo?.status!==null && this.courseInfo?.status!=="")
    this.courseDetailsForEdit.status = this.populateIdForValue(
      'status',
      this.courseInfo?.status
    );
    if(this.courseInfo?.format!==null && this.courseInfo?.format!=="" )
    this.courseDetailsForEdit.format = Number(this.populateIdForValue(
      'format',
      this.courseInfo?.format
    ));
    if( this.courseInfo?.type!==null && this.courseInfo?.type!=="")
    this.courseDetailsForEdit.type = Number(this.populateIdForValue(
      'type',
      this.courseInfo?.type
    ));
    if(this.courseInfo?.scoringOptions!==null && this.courseInfo?.scoringOptions!=="" )
       this.courseDetailsForEdit.scoringOptions =  Number(this.populateIdForValue(
      'scoringOptions',
      this.courseInfo?.scoringOption
    ));
    if(this.courseInfo?.proficiencyQuiz!==null && this.courseInfo?.proficiencyQuiz!=="")
        this.courseDetailsForEdit.proficiencyQuiz = Number(this.populateIdForValue(
        'proficiencyQuizTypes',
        this.courseInfo?.proficiencyQuiz
    ));
  }

  private populateIdForValue(fieldType: string, fieldValue?: string) {
    let fieldId = '';
    if (fieldValue == null) return fieldId;

    switch (fieldType) {
      case 'status':
        fieldId = this.courseBindData.statuses?.find(
          (cl: any) => cl.name == fieldValue
        ).value;
        break;
        case 'format':
          fieldId = this.courseBindData.formats?.find(
            (cl: any) => cl.name == fieldValue
          ).value;
          break;
          case 'type':
            fieldId = this.courseBindData.types?.find(
              (cl: any) => cl.name == fieldValue
            ).value;
            break;
        case 'scoringOptions':
          fieldId = this.courseBindData.scoringOptions?.find(
            (cl: any) => cl.name == fieldValue
          ).value;
          break;
        case 'proficiencyQuizTypes':
          fieldId = this.courseBindData.proficiencyQuizTypes?.find(
            (c1: any) => c1.name == fieldValue
          ).value;
          break;
    }
    return fieldId;
  }

  private validate(value: any) {
    return value !== null && value !== '' && value !== undefined;
  }


  validateForm() {
    this.errorMessages = [];
    this.mandatoryFields = this.getDefaultMandatoryFieldsObject();
    if (this.courseForm.invalid) {
      Object.keys(this.courseForm.controls).forEach((key) => {
        if (this.courseForm.get(key)?.errors) {
          let errorText = this.getErrorMessageText(key);
          this.errorMessages.push(errorText);
        }
      });
    }
    this.ValidateQuizTypeOnCourse();
  }

  private ValidateQuizTypeOnCourse(){
    if(this.courseForm?.value.format == CourseFormatConstants.SelfStudy && this.courseForm?.value.scoringOptions == CourseScoringOptionConstants.Pass_Fail){
        if(this.courseForm?.value.proficiencyQuiz == CourseProficiencyQuizConstant.eQMSAutomatedGrading || this.courseForm?.value.proficiencyQuiz == CourseProficiencyQuizConstant.eQMSTrainerGrading){
          this.errorMessages.push(this.getErrorMessageText('SelfStudyWithPassFail_eQMSQuiztype'));
        }
    }
    
    if(this.courseForm?.value.format == CourseFormatConstants.SelfStudy 
        && this.courseForm?.value.scoringOptions == CourseScoringOptionConstants.MinimumScore
        && this.courseForm?.value.proficiencyQuiz == CourseProficiencyQuizConstant.eQMSTrainerGrading)
      this.errorMessages.push(this.getErrorMessageText('SelfStudyWithMinScore_eQMSTrainier'));
  }

  private getErrorMessageText(labelName: string) {
    let errorText: string = '';
    switch (labelName) {      
      case 'name':
        errorText = CourseConstants.Course_Name_Required;
        this.mandatoryFields.name = true;
        break;
      case 'status':
        errorText = CourseConstants.Course_Status_Required;
        this.mandatoryFields.status = true;
        break;
      case 'format':
        errorText = CourseConstants.Course_Format_Required;
        this.mandatoryFields.format = true;
        break;
      case 'eqmsScopes':
        errorText = CourseConstants.Course_EqmsScope_Required;
        this.mandatoryFields.eqmsScopes = true;
        break;
      case 'description':
        errorText = CourseConstants.Course_Description_Required;
        this.mandatoryFields.description = true;
        break;
      case 'owners':
        errorText = CourseConstants.Course_Owners_Required;
        this.mandatoryFields.owners = true;
        break;
      case 'scoringOptions':
        errorText = CourseConstants.Course_ScoringOption_Required;
        this.mandatoryFields.scoringOptions = true;
        break;
      case 'recommendedMaxAttendees':
        errorText = CourseConstants.Course_RecommendedMaxAttendees_Required_CourseIsInstructorLed;
        this.mandatoryFields.recommendedMaxAttendees = true;
        break;
        case 'minimumPassingScore':
          errorText = CourseConstants.Course_MinimumPassingScore_Required_CourseIsInstructorLed;
          this.mandatoryFields.minimumPassingScore = true;
          break;
        case 'validityPeriodInterval':
          errorText = CourseConstants.Course_ValidityPeriodInterval_Required_ValidityRangeIsEntered;
          this.mandatoryFields.validityPeriodInterval = true;
          break;
          case 'validityPeriodRange':
          errorText = CourseConstants.Course_ValidityPeriod_must_Be_Greater_Than_Zero;
          this.mandatoryFields.validityPeriodRange = true;
          break;
        case 'proficiencyQuiz':
          errorText = CourseConstants.Course_ProficienyQuiz_Required;
          this.mandatoryFields.proficiencyQuiz = true;
          break;
        case 'SelfStudyWithPassFail_eQMSQuiztype':
          errorText = CourseConstants.Course_SelfStudy_With_PassFail_Validation;
          break;
        case 'SelfStudyWithMinScore_eQMSTrainier':
          errorText = CourseConstants.Course_SelfStudy_With_MinScore_Validation;
          break;
    }
    return errorText;
  }

  saveCourse(){
    this.validateForm();
    this.mapCourseToCourse();
    if(this.errorMessages.length == 0){
      // User in Edit Slider with no error in General Tab - Updating Tab Error Index to false
      if (this.isEditSlider)
        this.coursePersistenceService.updateTabErrorIndex(CourseConstants.Course_Create_General_Tab_Index, false);
      
      this.courseService.editCourseSlider$.subscribe((isEditCourse)=>{
      if(isEditCourse)
      {
        if(this.courseDetails.validityPeriod?.interval=== null || this.courseDetails.validityPeriod?.range === null)
        {
          this.courseDetails.validityPeriod = undefined;
        }

        // isCallForSave flag is set true to make sure, this function call is for Save in Edit Slider
        this.isCallForSave = true;

        // Second Parameter passed is for saving after Validation
        this.verifyIfCourseContainsInActiveAGForUpdate(this.courseDetails, true);
      }
      });
    }else {

      if (this.isEditSlider) {
        this.coursePersistenceService.updateTabErrorIndex(CourseConstants.Course_Create_General_Tab_Index
          , true);
      }
      document.querySelector('.p-tabview-panels')?.scrollTo(0, 0);
    }
  }

  // isSave - variable used to know call for save or Validation
  verifyIfCourseContainsInActiveAGForUpdate(courseDetailsInfo:any, isSave: boolean){
      this.inactiveGroupsSelected = this.assignmentGroupSharedDataService.findInactiveObjectsInValidatedList(courseDetailsInfo,this.validatedUsersList,
        this.coursePersistenceService.usersList
      );
      if(this.inactiveGroupsSelected != undefined && this.inactiveGroupsSelected.length > 0){
        this.isInActiveAssignmentGroupDialog = true;   
        this.InactiveAssignmentGroupField = this.inactiveGroupsSelected;
       }

      else {
        // No Inactive Assignment Group Present in the Qualified Trainer, else part executes
        // isSave flag - to know function call if for save or only Validation purpose in Tab Change
        this.saveDocumentwithInactiveAssignmentGroup(isSave);
      }
}

saveDocumentwithInactiveAssignmentGroup(saveWithInactiveAGsIfAny: boolean){
  this.isInActiveAssignmentGroupDialog = false;

  this.mapCourseToCourse();
  this.coursePersistenceService.updateCourseDetails(this.courseDetails);
  
  // if User Confirm's to save with Inactive AGs/ users, isSave = true && isCallForSave is a flag to check if the call is made for Saving the Course or Just Validating it
  if(saveWithInactiveAGsIfAny && this.isCallForSave) {
    this.isCallForSave = false;
    this.coursePersistenceService.updateCourse(this.isEditSlider); 
  }
}

closeConfirmationDailog(value : boolean){    
  this.isInActiveAssignmentGroupDialog = value
} 

disableQualifiedTrainers(){
  if(this.ifEqmsScopeIsSelected && this.ifFormatIsInstructorLed){
    this.enableControls(CourseConstants.CourseFormControls_QualifiedTrainers);
  }
  else{
    this.disableControls(CourseConstants.CourseFormControls_QualifiedTrainers);
  }
}

  validateFormat(){
    if(this.courseForm.getRawValue().format == CourseFormatConstants.InstructorLed){
      this.ifFormatIsInstructorLed = true;
      this.isFormatSelfStudy = false;    

      this.enableControls(CourseConstants.CourseFormControls_EstimatedDuration)
      this.enableControls(CourseConstants.CourseFormControls_RecommededMaxAttendees);
    }
    else if (this.courseForm.getRawValue().format == CourseFormatConstants.SelfStudy || 
    this.courseForm.getRawValue().format == null){
      this.isFormatSelfStudy = true;
      this.ifFormatIsInstructorLed = false;
      this.courseForm.patchValue({
        estimatedDuration:null,
        recommendedMaxAttendees:null,
        qualifiedTrainers: null
      })
      this.disableControls(CourseConstants.CourseFormControls_EstimatedDuration)
      this.disableControls(CourseConstants.CourseFormControls_RecommededMaxAttendees);
    }
    this.disableQualifiedTrainers();
  }

  validateScoringOption(){
    if(this.courseForm.getRawValue().scoringOptions == CourseScoringOptionConstants.MinimumScore){
      this.enableControls(CourseConstants.CourseFormControls_MinimumPassingScore);
      this.ifScoringOptionIsMinimumScore = true;
      this.courseForm.controls["minimumPassingScore"].setValue(0);
    }
    else if (this.courseForm.getRawValue().scoringOptions == CourseScoringOptionConstants.Pass_Fail){
      this.disableControls(CourseConstants.CourseFormControls_MinimumPassingScore);
      this.courseForm.patchValue({
        minimumPassingScore:null
      })
      this.ifScoringOptionIsMinimumScore=false;
    }
  }
  validateRadioButtons(){
    var validityPeriodRange = this.courseForm.getRawValue().validityPeriodRange
    //The below condition enables the validity period interval 
    //control only when the validity period range is not zero, null or an empty space. 
    if(validityPeriodRange !="" && validityPeriodRange != null && validityPeriodRange != "0"){
      this.enableControls(CourseConstants.CourseFormControls_ValidityPeriodInterval);
      this.isValidityPeriodRangeEntered = true;
    }
    else{
      this.disableControls(CourseConstants.CourseFormControls_ValidityPeriodInterval);
      this.courseForm.patchValue({
        validityPeriodInterval : null
      })
      this.isValidityPeriodRangeEntered = false;
    }
  }


  enableControls(controlNames: string | string[]) {
    if (typeof controlNames === 'string') {
      controlNames = [controlNames];
    }
    controlNames.forEach(controlName => {
      this.courseForm.controls[controlName].enable();
    });
  }

  disableControls(controlNames: string | string[]) {
    if (typeof controlNames === 'string') {
      controlNames = [controlNames];
    }
    controlNames.forEach(controlName => {
      this.courseForm.controls[controlName].disable();      
    });
  }

onRecommendedMaxAttendeesAndValidityPeriodChange(keyEvent: any) {
  const rawValue = keyEvent?.target?.value;
  const fieldId = keyEvent?.target?.id;

  const isValidityPeriodField = fieldId === 'validityPeriodRange';
  const isRecommendedMaxAttendeesField = fieldId === 'recommendedMaxAttendees';

  // If empty, undefined, null
  if (rawValue === '' || rawValue === undefined || rawValue === null) {
    keyEvent.target.value = '';
    if (isValidityPeriodField) {
      this.courseForm.get('validityPeriodRange')?.setValue(null);
    } else if (isRecommendedMaxAttendeesField) {
      this.courseForm.get('recommendedMaxAttendees')?.setValue(null);
    }
    return;
  }

  const numericValue = Number(rawValue);
  // If selected value is 0 or negative
  if (numericValue < 1) {
    keyEvent.target.value = '';
    if (isValidityPeriodField) {
      this.courseForm.get('validityPeriodRange')?.setValue(null);
    } else if (isRecommendedMaxAttendeesField) {
      this.courseForm.get('recommendedMaxAttendees')?.setValue(null);
    }
    return;
  }

  // Otherwise set numeric value properly for the correct field
  if (isValidityPeriodField) {
    this.courseForm.get('validityPeriodRange')?.setValue(numericValue);
  } else if (isRecommendedMaxAttendeesField) {
    this.courseForm.get('recommendedMaxAttendees')?.setValue(numericValue);
  }
}

  onMinimumPassingScoreChange(keyEvent: any) {
    if (Number(keyEvent.target.value) < 0) {
      keyEvent.target.value = null;
    }
    if (Number(keyEvent.target.value) > 100) {
      keyEvent.target.value = 100;
    }
  }

  getAssignementGroupsForEachScope(eqmsScopes: any){
    if (!eqmsScopes) {
      return;
    }
    const request = new AssignmentGroupsRequest(eqmsScopes, this.documentAssignmentTypes);

    this.assignmentGroupService.getAssignmentGroups(request).subscribe((assignmentGroups:any) => {
          this.assignmentGroups = assignmentGroups;
          
          // Separate assignment groups for Qualified Trainers and Course Owners
          const qualifiedTrainerAssignmentGroups = assignmentGroups.filter(
            (ag: any) => ag.assignment === CourseConstants.AssignmentGroup_QualifiedTrainerAssignment
          );
          const courseOwnerAssignmentGroups = assignmentGroups.filter(
            (ag: any) => ag.assignment === CourseConstants.AssignmentGroup_CourseOwnerAssignment
          );

          this.usersAndAssignmentGroupList = [];
          this.usersAndAssignmentGroupList = [...this.userList];

          this.usersAndAssignmentGroupListForQualifiedTrainers = [];
          this.usersAndAssignmentGroupListForQualifiedTrainers = [...this.userList];
          for (let ag of qualifiedTrainerAssignmentGroups) {
            this.usersAndAssignmentGroupListForQualifiedTrainers.unshift({
              value:ag.name,
              name: ag.name
            });
          }

          // Owners User List
          this.usersAndAssignmentGroupListForCourseOwners = [];
          this.usersAndAssignmentGroupListForCourseOwners = [...this.userList];
          for (let ag of courseOwnerAssignmentGroups) {
            this.usersAndAssignmentGroupListForCourseOwners.unshift({
              value: ag.name,
              name: ag.name
            });
          }

          // To get qualifiedTrainersInfo and append in the list to dispaly in Edit Slider
          var qualifiedTrainersInfo = this.courseDetailsForEdit?.qualifiedTrainers;
          if(qualifiedTrainersInfo !== null || qualifiedTrainersInfo !== undefined){
            const qualifiedTrainersInfoSet = new Set(qualifiedTrainersInfo?.map((obj: any) => obj["assignedUserName"]));
            const usersAndAssignmentGroupListSet = new Set(this.usersAndAssignmentGroupListForQualifiedTrainers.map((obj: any) => obj["name"]));
            var InActiveAGs = [...qualifiedTrainersInfoSet].filter(item => !usersAndAssignmentGroupListSet.has(item));
            for (let ag of InActiveAGs) {
              this.usersAndAssignmentGroupListForQualifiedTrainers.unshift({
                value:ag,
                name: ag
              });
            }
          }

          // To get courseOwnersInfo and append in the list to dispaly in Edit Slider
          var courseOwnersInfo = this.courseDetailsForEdit?.owners;
          if(courseOwnersInfo !== null || courseOwnersInfo !== undefined){
            const courseOwnersInfoSet = new Set(courseOwnersInfo?.map((obj: any) => obj["assignedUserName"]));
            const usersAndAssignmentGroupListSetForOwners = new Set(this.usersAndAssignmentGroupListForCourseOwners.map((obj: any) => obj["name"]));
            var InActiveAGs = [...courseOwnersInfoSet].filter(item => !usersAndAssignmentGroupListSetForOwners.has(item));
            for (let ag of InActiveAGs) {
              this.usersAndAssignmentGroupListForCourseOwners.unshift({
                value:ag,
                name: ag
              });
            }
          }

          this.reassignCourseFormWithAssignmentValues();
          this.qualifiedTrainersUserList = [...this.usersAndAssignmentGroupListForQualifiedTrainers];
          this.ownersUserList = [...this.usersAndAssignmentGroupListForCourseOwners];
          });
  }
  
  private reassignCourseFormWithAssignmentValues(): void {
    const qualifiedTrainersValue = this.courseForm.getRawValue().qualifiedTrainers?.filter((value: string) =>
    this.usersAndAssignmentGroupList.some((item: any) => item.value === value)
    );
    this.courseForm.patchValue({ qualifiedTrainers: qualifiedTrainersValue });
    if (this.courseForm.getRawValue().owners != null && this.courseForm.getRawValue().owners != undefined) {
    const courseOwnersValue = this.courseForm.getRawValue().owners.filter((value: string) =>
    this.usersAndAssignmentGroupList.some((item: any) => item.value === value)
    );
    this.courseForm.patchValue({ owners: courseOwnersValue });
  }
    this.courseService.editCourseMetaDataLoaded$.next(true);
}

  getAssignementGroupsForEachScopeOnEdit(): Promise<void> {
  return new Promise((resolve) => {
    const eqmsScopes = this.eQMSScope;
    if (!eqmsScopes) {
      this.courseService.editCourseMetaDataLoaded$.next(true);
      resolve();
      return;
    }
    const request = new AssignmentGroupsRequest(
      eqmsScopes.map((scope: number | string) => scope.toString()),
      this.documentAssignmentTypes
    );

    this.assignmentGroupService.getAssignmentGroups(request).subscribe((assignmentGroups:any) => {
      this.assignmentGroups = assignmentGroups;
      this.usersAndAssignmentGroupList = [];
      this.usersAndAssignmentGroupList = [...this.userList];

      // Separate assignment groups for Qualified Trainers and Course Owners
      const qualifiedTrainerAssignmentGroups = assignmentGroups.filter(
        (ag: any) => ag.assignment === CourseConstants.AssignmentGroup_QualifiedTrainerAssignment
      );
      const courseOwnerAssignmentGroups = assignmentGroups.filter(
        (ag: any) => ag.assignment === CourseConstants.AssignmentGroup_CourseOwnerAssignment
      );
      
      this.usersAndAssignmentGroupListForQualifiedTrainers = [];
      this.usersAndAssignmentGroupListForQualifiedTrainers = [...this.userList];
      for (let ag of qualifiedTrainerAssignmentGroups) {
        this.usersAndAssignmentGroupListForQualifiedTrainers.unshift({
          value:ag.name,
          name: ag.name
        });
      }

      // Owners User List
      this.usersAndAssignmentGroupListForCourseOwners = [];
      this.usersAndAssignmentGroupListForCourseOwners = [...this.userList];
      for (let ag of courseOwnerAssignmentGroups) {
        this.usersAndAssignmentGroupListForCourseOwners.unshift({
          value: ag.name,
          name: ag.name
        });
      }

      for (let ag of assignmentGroups) {
        this.usersAndAssignmentGroupList.unshift({
          value:ag.name,
          name: ag.name
        });
      }

      // Refreshing dropdown data sources for edit mode when scopes change.
      this.qualifiedTrainersUserList = [...this.usersAndAssignmentGroupListForQualifiedTrainers];
      this.ownersUserList = [...this.usersAndAssignmentGroupListForCourseOwners];

      this.reassignCourseFormWithAssignmentValues();
      resolve();
    });
  });
}

  async processUsersList()
  {
    if(!this.isEditSlider)
    {
      this.ownersUserList = cloneDeep(this.usersAndAssignmentGroupListForCourseOwners);
      this.qualifiedTrainersUserList = cloneDeep(this.usersAndAssignmentGroupListForQualifiedTrainers);
    }
    else
    {
      this.usersAndAssignmentGroupList = [
        ...new Map(
          [
            ...this.usersAndAssignmentGroupListForQualifiedTrainers,
            ...this.usersAndAssignmentGroupListForCourseOwners
          ].map(item => [item.value, item]) // assuming `value` is unique
          ).values()
        ];

      this.ownersUserList = cloneDeep(this.usersAndAssignmentGroupListForCourseOwners);
      this.usersAndAssignmentGroupList = cloneDeep(this.usersAndAssignmentGroupList);
      this.qualifiedTrainersUserList = [...this.usersAndAssignmentGroupListForQualifiedTrainers];
      this.ownersWithInactiveUserList=cloneDeep(this.usersAndAssignmentGroupListForCourseOwners);
      this.qualifiedTrainersWithInactiveUsers=[...this.usersAndAssignmentGroupListForQualifiedTrainers];
      this.usersListToValidate=[];

      this.usersListToValidate.push({
        userType:UserType.Owners,
        userAssignmentList: this.courseDetailsForEdit.owners
       });

       this.usersListToValidate.push({
        userType:UserType.QualifiedTrainers,
        userAssignmentList: this.courseDetailsForEdit.qualifiedTrainers
       });       

       // Fetch and process the validated users list
      this.validatedUsersList = await firstValueFrom(this.usersService.validateUsers(this.usersListToValidate));
      this.coursePersistenceService.validatedUsersList = this.validatedUsersList;
      
      let userListToValidate = this.usersAndAssignmentGroupList;

    // Extract non-terminated users and map them to the desired structure
    const nonTerminatedUserList = this.validatedUsersList
      .flatMap((user: any) => user.userAssignmentList || [])
      .filter((user: any) => !user.isTerminated)
      .map((user: any) => ({
        value: user.value,
        name: user.assignedUserName,
        type: user.assignmentType,
        assignmentId: user.assignmentId,
        isactive: user.isActive,
      }));
    userListToValidate = userListToValidate.concat(nonTerminatedUserList);
    this.coursePersistenceService.usersList = userListToValidate;

      if (this.validatedUsersList.length > 0) {
      // Iterate through each userInfo in the validatedUsersList

      this.usersWithInactiveUsersAndAssignmentGroups = this.validatedUsersList
          .filter((assignment: { userType: UserType }) => (assignment.userType === UserType.QualifiedTrainers
        || assignment.userType === UserType.Owners)).map((x: { userAssignmentList: any; })=>x.userAssignmentList);
      
      
// Initialize the array with userList
this.usersWithInactiveUsersAndAssignmentGroupsForMapping = [...this.userList];
// Append each item from usersWithInactiveUsersAndAssignmentGroups to the array
this.usersWithInactiveUsersAndAssignmentGroups.forEach((data: any) => {
  // Assuming 'data' contains an array of items you want to push
  data.forEach((element: { assignmentType: number; assignedUserName: any; }) => {
    if(element.assignmentType === 1)
    this.usersWithInactiveUsersAndAssignmentGroupsForMapping.push({name: element.assignedUserName,value:element.assignedUserName});
  });  
});
      this.validatedUsersList.forEach((userInfo: { userAssignmentList: any[]; userType: any; }) => {
          // Determine the target list based on user type
          let targetList: { name: string, value: string }[] = [];

          switch (userInfo.userType) {
              case UserType.Owners:
                  targetList = this.ownersWithInactiveUserList;
                  break;
              case UserType.QualifiedTrainers:
                  targetList = this.qualifiedTrainersWithInactiveUsers;
                  break;
              default:
                  return; // Skip unknown user types
          }

          
          // Add filtered assignments to the target list
          userInfo.userAssignmentList.forEach(user => {
              const userItem = { name: user.assignedUserName, value: user.assignedUserName };

              // Check if the item already exists in the target list
              if (!targetList.some(item => item.name === userItem.name && item.value === userItem.value)) {
                  targetList.push(userItem);
                        }
                    });
                });
              }
      this.ownersUserList = this.removeDuplicatesFromUserList(
        [...this.ownersWithInactiveUserList, ...this.ownersUserList]
      );
      this.qualifiedTrainersUserList = this.removeDuplicatesFromUserList(
        [...this.qualifiedTrainersWithInactiveUsers, ...this.qualifiedTrainersUserList]
      );
    }
}

  /**
 * Removes duplicates from user list based on unique 'value' property
 * Prevents duplicate entries during page load by keeping first occurrence
 */
private removeDuplicatesFromUserList(list: any[]): any[] {
  if (!list || list.length === 0) {
    return list;
  }
  
  const seen = new Map<string, boolean>();
  return list.filter(item => {
    const key = item.value || item.name;
    if (seen.has(key)) {
      return false;
    }
    seen.set(key, true);
    return true;
  });

}
}
